<template>
  <el-menu mode="horizontal" @select="handleMenuSelect" ref="headerMenu">
    <template v-for="(menu, menuIndex) in menuHeader">
      <d2-layout-header-aside-menu-item v-if="menu.children === undefined" :menu="menu" :key="menuIndex"/>
      <d2-layout-header-aside-menu-sub v-else :menu="menu" :key="menuIndex"/>
    </template>
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'
import menuMixin from '../mixin/menu'
import d2LayoutMainMenuItem from '../components/menu-item/index.vue'
import d2LayoutMainMenuSub from '../components/menu-sub/index.vue'
export default {
  name: 'd2-layout-header-aside-menu-header',
  mixins: [
    menuMixin
  ],
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem,
    'd2-layout-header-aside-menu-sub': d2LayoutMainMenuSub
  },
  computed: {
    ...mapState({
      menuHeader: state => state.d2admin.menuHeader,
      currentAppInfo: state => state.d2admin.currentAppInfo
    })
  },
  watch: {
      // 监听路由 控制顶部菜单激活状态
      /*'$route.matched': {
          handler (val) {
              this.active = val[val.length - 1].path
              this.$nextTick(() => {
                  if (this.menuHeader.length > 0) {
                      this.$refs.headerMenu.activeIndex = this.active
                  }
              })
          },
          immediate: true
      }*/
      '$route': {
          handler (val) {
              //如果当前APP信息中有URL信息，尝试激活它
              if(this.currentAppInfo.url){
                  this.active = this.currentAppInfo.url
              }else{
                  this.active = val.path
                  if(this.active.endsWith('/')){
                      this.active = this.active.substr(0,this.active.length-1)
                  }
              }
              this.$nextTick(() => {
                  if (this.menuHeader.length > 0) {
                      this.$refs.headerMenu.activeIndex = this.active
                  }
              })
          },
          immediate: true
      }
  }
}
</script>
